import { google, ics, office365, yahoo } from "calendar-link"
import { CalendarEvent } from "./AddToCalendar"

export type CalendarType = "google" | "office365" | "yahoo" | "ics"

export const generateCalendarUrl = (event: CalendarEvent, type: CalendarType): string => {
    switch (type) {
        case "google":
            return google(event)
        case "office365":
            // Office365 link requires URL replacement workaround
            return office365(event).replace(/\/deeplink\//, "/action/")
        case "yahoo":
            return yahoo(event)
        case "ics":
            return ics(event)
        default:
            throw new Error(`Unsupported calendar type: ${type}`)
    }
}

export const openCalendarUrl = (url: string): void => {
    window.open(url, "_blank", "noopener,noreferrer")
}
